<template>
    <div id="webview-internal-wrapper" class="webview-internal" v-loading="loading">
        <!--<iframe src="" frameborder="0" id="internalframe"></iframe>-->
    </div>
</template>
<script>
  import {mapState} from 'vuex';
  import {onMessage, postMessage} from '../../../../utils/event-bus';
  import Constants from '../../../../utils/constants';

  export default {
    data() {
      return {
        loading: false,
        iframeUrl: ''
      };
    },
    props: {
      customize: {
        type: Object,
        default(){
          return {};
        }
      }
    },
    computed: {
      ...mapState({
        webview: state => state.kiaf.webview
      })
    },
    watch: {
      'webview.url': function(){
        // console.log('internal webview.url>>>>>>>>>>>>>' + this.webview.url);
        if(this.webview.internal){
            let webviewId = this.webview.id;
            let childNodes = document.getElementById('webview-internal-wrapper').getElementsByTagName('iframe');
            console.log('webview>>>childNodes', childNodes);
            for(let i = 0; i < childNodes.length; i++){
                if(childNodes[i] && childNodes[i].style){
                    childNodes[i].style.display = 'none';
                    console.log('webview>>>' + i, childNodes[i].style);
                }
            }
            let child = document.getElementById('internalframe' + webviewId);
            if(!child){
              this.createIframe(webviewId);
            } else {
              let nextQuery = '';
              let prevQuery = '';
              if(this.webview.url){
                let nextQueryArr = this.webview.url.split('?');
                if(nextQueryArr && nextQueryArr.length > 1){
                  nextQuery = nextQueryArr[1];
                }
              }
              if(child.src){
                let prevQueryArr = child.src.split('?');
                if(prevQueryArr && prevQueryArr.length > 1){
                  prevQuery = prevQueryArr[1];
                }
              }
              // console.log('internal webview.url>>>>>>>>>>>>>nextQuery', nextQuery);
              // console.log('internal webview.url>>>>>>>>>>>>>prevQuery', prevQuery);
              if(!webviewId || webviewId == 0 || (prevQuery != nextQuery)){ // 没有传webviewid，则每次都刷新,或者参数发生了变化
                document.getElementById('webview-internal-wrapper').removeChild(child);
                this.createIframe(webviewId);
              } else {
                child.style.display = 'block';
              }
            }
        }
      }
    },
    methods: {
       createIframe(webviewId){
         let webviewUrl = this.webview.url;
         let webviewSign = this.webview.sign;
         let internalframe = document.createElement('iframe');
         internalframe.setAttribute('src', webviewUrl);
         internalframe.setAttribute('frameborder', 0);
         internalframe.setAttribute('id', 'internalframe' + webviewId);
         internalframe.setAttribute('width', '100%');
         internalframe.setAttribute('height', '100%');
         internalframe.setAttribute('margin', '0px');
         internalframe.setAttribute('padding', '0px');
         internalframe.setAttribute('allowfullscreen', true);
         internalframe.setAttribute('allow', 'geolocation; microphone; camera; midi; encrypted-media;');

         document.getElementById('webview-internal-wrapper').appendChild(internalframe);
         this.loading = true;
         // console.log('internal webview internalframe.src>>>>>>>>>>>>>' + internalframe.src);
         // console.log('internal webview customize.maxLoading>>>>>>>>>>>>>' + this.customize);
         internalframe.onload = () => {
           this.loading = false;
           postMessage(Constants.EVENT_BUS_CODE_WEBVIEW_ONLOAD, {id: webviewId, sign: webviewSign, url: webviewUrl});
         };
         let maxLoading = this.customize.maxLoading || 3000;
         setTimeout(() => {
           this.loading = false;
         }, maxLoading);
      }
    },
    mounted(){
      onMessage(Constants.EVENT_BUS_CODE_REMOVE_TAG, (data) => {
        let webviewId = data.tagId;
        this.$global.removeWebview(webviewId);
        let webview = document.getElementById('internalframe' + webviewId);
        if(webview){
          document.getElementById('webview-internal-wrapper').removeChild(webview);
        }
      }, this);
    }
  };
</script>
<style scoped>
    .webview-internal {
        width: 100%;
        height: 100%;
        /*margin-top: -10px;*/
        /*height: calc(100% - 2.6rem);*/
        /*display: flex;*/
        /*flex: 1;*/
        position: relative;
        margin:0px;
        padding: 0px;
    }
</style>
